var map = {
	"./button-text-block-quote-on.svg": 2223,
	"./button-text-block-quote.svg": 2224,
	"./button-text-bold-on.svg": 2225,
	"./button-text-bold.svg": 2226,
	"./button-text-bulleted-list-on.svg": 2227,
	"./button-text-bulleted-list.svg": 2228,
	"./button-text-deleted-on.svg": 2229,
	"./button-text-deleted.svg": 2230,
	"./button-text-formatting.svg": 1032,
	"./button-text-inline-code-on.svg": 2231,
	"./button-text-inline-code.svg": 2232,
	"./button-text-italic-on.svg": 2233,
	"./button-text-italic.svg": 2234,
	"./button-text-numbered-list-on.svg": 2235,
	"./button-text-numbered-list.svg": 2236,
	"./button-text-underlined-on.svg": 2237,
	"./button-text-underlined.svg": 2238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2222;